export default function IconClose() {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.3638 18.8646L18.3638 11.7939M18.3638 18.8646L11.2927 18.8643M18.3638 18.8646L5.63585 6.13672"
				stroke="white"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	)
}
